import { jsx as _jsx } from "react/jsx-runtime";
import CenteredLoader from '../components/loader/loader';
import RadialLayout from '../components/layout/radial';
import dynamic from 'next/dynamic';
var AuthenticationContainer = dynamic(function () {
  return import('../components/ui/authentication');
}, {
  loading: function loading() {
    return /*#__PURE__*/_jsx(CenteredLoader, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('../components/ui/authentication')];
    },
    modules: ["signup.tsx -> " + '../components/ui/authentication']
  }
});
/* eslint-disable-next-line */

export function Signup(props) {
  return /*#__PURE__*/_jsx(AuthenticationContainer, {
    isSignup: true
  });
}
Signup.title = 'Signup';

Signup.getLayout = function (page) {
  return /*#__PURE__*/_jsx(RadialLayout, {
    children: page
  });
};

export default Signup;